import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { CNS_INSTAGRAM_SCREENSHOT, MARCIO_PHOTO, cnsFacts } from "../data/content";
import { offer } from "../data/offer";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
export function BehindCnsSection() {
  return <section id="quien-esta-detras" className="bg-gold-cream py-16 md:py-24" data-id="element-17" data-mp="28l2wc3nnz8ml">
      <div className="wrap" data-id="element-18" data-mp="1ayvpen3w1472">
        <div className="grid items-center gap-12 md:grid-cols-[1.1fr_1fr] md:gap-16" data-id="element-19" data-mp="1azon6ykvcjd2">
          <div data-id="element-20" data-mp="1fyi4l23a0uii">
            <SectionHeading align="left" eyebrow="Quién está detrás" title={<>
                  Una guía de <span className="text-gold-dark" data-id="element-22" data-mp="1pn029ag9elhx">Celulares Nuevos Saavedra</span>
                </>} data-id="element-21" data-mp="1fxzyldqtb1xe" />
            <div className="mt-6 space-y-4 text-[17px] text-muted" data-id="element-23" data-mp="s6um98k2yrru">
              <p data-id="element-24" data-mp="x6pbl7o7j9as">
                CNS es una comunidad Apple de Argentina con local en Saavedra, CABA. Todos los días comparte consejos
                sobre iPhone, iPad y Mac con más de 185 mil seguidores.
              </p>
              <p data-id="element-25" data-mp="1uyagy2t6vkkz">
                Tu iPhone, Tu Estudio reúne esa experiencia en una necesidad concreta: que la cámara de tu iPhone
                trabaje para tu emprendimiento.
              </p>
            </div>
            <dl className="mt-8 grid grid-cols-3 gap-3" data-id="element-26" data-mp="1m45sfq1j2l8m">
              {cnsFacts.map(fact => <div key={fact.label} className="rounded-xl border border-line bg-white px-3 py-4 text-center" data-id="element-27" data-mp="1h7fh1g0o4dtj">
                  <dt className="sr-only" data-id="element-28" data-mp="1c5gdo64xhgwl">{fact.label}</dt>
                  <dd className="display-title text-[clamp(22px,3vw,36px)] text-gold-dark" data-id="element-29" data-mp="176wq61aorx24">{fact.value}</dd>
                  <dd className="mt-1 text-[11px] leading-tight text-muted md:text-xs" data-id="element-30" data-mp="1374q6czcyz8d">{fact.label}</dd>
                </div>)}
            </dl>
            <a href={offer.instagramUrl} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-1.5 font-bold text-ink underline underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-dark" data-id="element-31" data-mp="2xk4b8lmicln1">
              Ver @celularesnuevossaavedra
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="ly275oa9svhp" />
            </a>
          </div>

          <div className="mx-auto w-full max-w-[260px] rounded-[40px] md:max-w-[300px] border-[10px] border-night bg-night shadow-[0_30px_60px_rgba(20,39,85,0.25)]" data-id="element-33" data-mp="pyvqs5gojo4s">
            <img src={CNS_INSTAGRAM_SCREENSHOT} alt="Perfil de Instagram de Celulares Nuevos Saavedra con 185 mil seguidores" loading="lazy" className="block h-auto w-full rounded-[30px]" data-id="element-34" data-mp="1in9risz5kyk1" />
          </div>
        </div>

        <div className="mt-14 grid items-center gap-6 overflow-hidden rounded-3xl bg-night text-white md:mt-24 md:grid-cols-2 md:gap-0" data-id="element-35" data-mp="3pdr587k4v25w">
          <img src={MARCIO_PHOTO} alt="Marcio, de Celulares Nuevos Saavedra, sosteniendo el libro Tu iPhone, Tu Estudio" width={1024} height={1536} loading="lazy" className="block h-full max-h-[440px] w-full object-cover object-top md:max-h-[640px]" data-id="element-36" data-mp="3udc4yk74nejo" />
          <div className="px-6 pb-10 md:px-12 md:py-12" data-id="element-37" data-mp="3vrdgz555kld9">
            <span className="text-xs font-bold uppercase tracking-[2.5px] text-gold" data-id="element-38" data-mp="3qvy52iqpgzjh">Presentado por</span>
            <h3 className="display-title mt-3 text-[clamp(44px,5vw,64px)]" data-id="element-39" data-mp="335tyc2i80jo9">
              Marcio, <span className="text-gold" data-id="element-40" data-mp="2y70kua2xoso3">de CNS</span>
            </h3>
            <p className="mt-5 text-[17px] text-haze" data-id="element-41" data-mp="3culqobr715zp">
              La misma cara que conocés por los consejos de iPhone de Celulares Nuevos Saavedra. Ahora, con una guía
              para que aprendas a fotografiar y grabar lo que vendés.
            </p>
            <p className="mt-4 font-display text-2xl font-bold uppercase tracking-[3px] text-white" data-id="element-42" data-mp="2kcq6mmokcgwa">
              Aprendé. Creá. Mostrá.
            </p>
            <div className="mt-8" data-id="element-43" data-mp="1iovwrfjmsnfk">
              <CtaButton href="#offer-details" data-id="element-44" data-mp="1ipnqslxkyd3q">Quiero el pack completo</CtaButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}